export default "__VITE_ASSET__$VA79Ft___"